import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "youtube",
  "use": "youtube-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"youtube\"><path d=\"M27.6 24.362l-7.383 3.317c-.197.089-.424-.047-.424-.252v-6.842c0-.208.233-.343.43-.25l7.383 3.526a.272.272 0 01-.006.5M31.392 15H15.608C12.51 15 10 17.365 10 20.283v7.434C10 30.635 12.51 33 15.608 33h15.784C34.49 33 37 30.635 37 27.717v-7.434C37 17.365 34.49 15 31.392 15\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol